var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prevent-full-width mx-auto mt-4"},[_c('createTicketForm',{attrs:{"title":"Interesse oder Fragen? Schreib uns eine Nachricht!","contactForm":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }